import { render, staticRenderFns } from "./Death.vue?vue&type=template&id=7527d88e&"
import script from "./Death.vue?vue&type=script&lang=js&"
export * from "./Death.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports